module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gd-Ha-Ib-Ja.4ce47522.png";